import type { FaireProductEntity } from "../../entity_types/product";

export const p_45mk3adddx: FaireProductEntity = {
  token: "p_45mk3adddx",
  type: "product",
  name: "The Best-Seller Routine",
  brandToken: "b_4240zqg5kc",
  brandName: "Ceremonia",
  imageUrl:
    "https://cdn.faire.com/fastly/dc4d4460c19d157a49a1067b607197d8c38e5a6e75b1c518e13c2761e5a18c3b.jpeg?bg-color=FFFFFF&dpr=1&fit=crop&format=jpg&height=960&width=720",
  priceDollars: 48,
  description: "The Best-Seller Routine for wholesale.",
  tags: ["haircare"],
  caseSize: 1,
  isBestseller: true,
  msrpDollars: 96,
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-04-14T00:00:00.000Z",
    importedBy: "ceremonia-brand-prototype",
  },
  categoryTokens: [],
};
